import { render, staticRenderFns } from "./carmelcourse.vue?vue&type=template&id=0e581dbc"
import script from "./carmelcourse.vue?vue&type=script&lang=js"
export * from "./carmelcourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports